import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #hideTimeout;

  async copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    try {
      await navigator.clipboard.writeText(copyContent);
    } catch {
      return;
    }

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (!(copySuccessMessage instanceof Element)) return;

    copySuccessMessage.classList.remove('visually-hidden');
    clearTimeout(this.#hideTimeout);
    this.#hideTimeout = setTimeout(() => {
      copySuccessMessage.classList.add('visually-hidden');
    }, 2000);
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
